var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-custom-phone" },
    [
      _vm.prefix
        ? _c("input", {
            staticClass: "rb-custom-phone__prefix",
            attrs: { type: "text", readonly: "" },
            domProps: { value: _vm.prefix },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("rb-textfield", {
        staticClass: "rb-custom-phone-field",
        attrs: {
          type: "text",
          name: "phoneField",
          label: _vm.translation("registration.phone"),
          "label-optional":
            " - " + _vm.translation("get_support.contact_us_form.optional"),
          error: _vm.translation("registration.phone_error"),
          validation: _vm.$v.phoneField,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }